<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li>Colaboradores / Candidatos</li>
                        </ul>
                    </section>
                    <section class="col-sm-6" v-canaccess="'/inativartodoscolaboradores'">
                        <br />
                        <button type="button" class="btn-large-40 btn-red uppercase float-right" @click="openInativar()">Inativar colaboradores</button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Colaboradores / Candidatos</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <br />
                                    <label class="text-center">Situação</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="1" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Candidato</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="2" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Disponível</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="3" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Colaborador</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="nmCompleto">Nome</label>
                                    <input type="text" class="form-control" name="nmCompleto" placeholder="Nome" v-model="filter.nmCompleto" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="email">E-mail</label>
                                    <input type="text" class="form-control" name="email" placeholder="E-mail" v-model="filter.email" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cargoId">Cargo</label>
                                    <select v-select="{ dataitem: 'Cargo', default: 'Todos', filters: { attributeBehavior: 'CargoHierarquiaEspecificos' } }" v-model="filter.cargoId" class="form-control" name="cargoId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="escolaId">Escola</label>
                                    <select v-select="{ dataitem: 'Escola', default: 'Todos', filters: { attributeBehavior: 'escolaColaborador' } }" v-model="filter.escolaId" class="form-control" name="escolaId"></select>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="cpf">CPF</label>
                                    <input type="text" class="form-control" name="cpf" v-mask="mask_cpf" placeholder="CPF" v-model="filter.cpf" />
                                </div>
                                <div class="form-group col-md-1">
                                    <label for="telefoneDDD">DDD</label>
                                    <input type="text" class="form-control" name="telefoneDDD" v-mask="'##'" maxlength="2" placeholder="DDD" v-model="filter.telefoneDDD" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="telefoneNumero">Telefone</label>
                                    <input type="text" class="form-control" name="telefoneNumero" v-mask="mask_tel" placeholder="Telefone" v-model="filter.telefoneNumero" />
                                </div>
                                <div class="form-group col-md-1">
                                    <label for="celularDDD">DDD</label>
                                    <input type="text" class="form-control" name="celularDDD" v-mask="'##'" maxlength="2" placeholder="DDD" v-model="filter.celularDDD" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="celularNumero">Celular</label>
                                    <input type="text" class="form-control" name="celularNumero" v-mask="mask_cel" placeholder="Celular" v-model="filter.celularNumero" />
                                </div>                                
                                <div class="form-group col-md-4">
                                    <div class="form-group"  v-if="!carregandoEstado">
                                        <label for="estadoId">Estado</label>
                                        <select v-select="{ dataitem: 'Estado', default: 'Todos', filters: { regiaoId: filter.regiaoId } }" @change="trocandoEstado" v-model="filter.estadoId" class="form-control" name="estadoId"></select>
                                    </div>
                                </div>
                                <div class="form-group col-md-5" v-if="!municipioPorEstado">
                                    <label for="municipioId">Município</label>
                                    <select v-select="{ dataitem: 'Municipio', default: 'Todos', filters: { estadoId: filter.estadoId } }" @change="trocandoNanoRegiao" v-model="filter.municipioId" class="form-control" name="municipioId"></select>                                    
                                </div>
                            </div>

                            <div class="row" v-if="buscaAvancada" v-canaccess="'/buscacolaboradores'">

                                <div class="form-group col-md-6">
                                    <label for="regiaoId">Região</label>
                                    <select v-select="{ dataitem: 'Regiao', default: 'Todos' }" @change="trocandoRegiao" v-model="filter.regiaoId" class="form-control" name="regiaoId"></select>
                                </div>
                                <div class="form-group col-md-6" v-if="!municipioPorEstado">
                                    <label for="mesoRegiaoId">Mesorregião</label>
                                    <select v-select="{ dataitem: 'MesoRegiao', default: 'Todos', filters:{estadoId: filter.estadoId} }" @change="trocandoMicroRegiao" v-model="filter.mesoRegiaoId" class="form-control" name="mesoRegiaoId"></select>
                                </div>
                                <div class="form-group col-md-6" v-if="!carregandoMicroRegiao">
                                    <label for="microRegiaoId">Microrregião</label>
                                    <select v-select="{ dataitem: 'MicroRegiao', default: 'Todos', filters:{mesoRegiaoId: filter.mesoRegiaoId} }" v-model="filter.microRegiaoId" class="form-control" name="microRegiaoId"></select>
                                </div>
                                <div class="form-group col-md-6"  v-if="!carregandoNanoRegiao">
                                    <label for="nanoRegiaoId">Nanorregião</label>
                                    <select v-select="{ dataitem: 'NanoRegiao', default: 'Todos', filters:{municipioId: filter.municipioId} }" v-model="filter.nanoRegiaoId" class="form-control" name="nanoRegiaoId"></select>
                                </div>
                            </div>

                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                            <button type="button" v-canaccess="'/buscacolaboradores'" style="margin-left: 5px" class="btn-large-40 btn-red uppercase" @click="buscaAvancadaToggle()">Busca Avançada</button>
                            <button type="button" class="btn-large-40 btn-default uppercase" @click="executeClear(filter)" style="margin-left: 5px;">Limpar</button>

                            <br />
                            <br />

                        </form>
                    </div>

                    <div v-if="filtro">
                        <div class="table-responsive standard-table header-cinza">
                            <table>
                                <thead>
                                    <tr>
                                        <th title="E-mail" style="text-align:center;">E-mail <i @click="executeOrderBy('Email')" class="fa fa-sort"></i></th>
                                        <th title="CPF" style="text-align:center;">CPF <i @click="executeOrderBy('cpf')" class="fa fa-sort"></i></th>
                                        <th title="Nome" style="text-align:center;">Nome <i @click="executeOrderBy('NmCompleto')" class="fa fa-sort"></i></th>
                                        <!-- <th title="Data de Nascimento">Nasc. <i @click="executeOrderBy('DtNascimento')" class="fa fa-sort"></i></th>-->
                                        <th title="Escola" style="text-align:center;">Escola </th>
                                        <th style="text-align:center;">Cargo</th>
                                        <th title="Situação" style="text-align:center;">Situação <i @click="executeOrderBy('situacaoJobs')" class="fa fa-sort"></i></th>
                                        <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                        <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 15ch; overflow: hidden; text-align:center;">
                                            {{ item.email }}
                                        </td>
                                        <td style="text-align:center;">{{ item.cpf }}</td>
                                        <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 15ch; overflow: hidden;text-align:center;">{{ item.nmCompleto }}</td>
                                        <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 30ch; overflow: hidden; text-align:center;">
                                            <span v-for="item2 in item.collectionColaboradorEscolaAtiva" @mouseover="colaboradorIdHover = item2.colaboradorId; escolaIdHover = item2.escolaId" @mouseleave="escolaIdHover = 0" v-bind:key="item2.escolaId" name="nmescolas">
                                                {{ item2.escola.nomeEscola }}<br />
                                            </span>
                                        </td>
                                        <td style="text-align:center;">
                                            <span v-for="item3 in item.collectionColaboradorEscolaAtiva">
                                                <span v-for="item4 in item3.collectionColaboradorEscolaCargo" v-bind:key="item3.cargoId" name="nmcargos" :class="{destaca : colaboradorIdHover == item4.colaboradorId && escolaIdHover == item4.escolaId }">
                                                    {{ item4.cargo.dsCargo }}<br />
                                                </span>
                                            </span>
                                        </td>
                                        <!--<td>{{ item.dtNascimento }}</td>-->
                                        <td style="text-align:center;">{{ item.situacaoJobs.nome }}</td>

                                        <td class="text-center" width="120">
                                            <!-- Task-1865 -->
                                            <span v-if="item.collectionColaboradorEscolaAtiva.length>1 && item.situacaoJobs.nome=='Colaborador'">
                                                <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Adicionar Escola x Cargo" @click="openAddEscolaCargo({ colaboradorId: item.colaboradorId, nmCompleto: item.nmCompleto })" v-canaccess="'/colaborador/form-add-escola-cargo'">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </span>
                                            
                                            <button v-if="item.podeAlterarSenha && item.colaboradorLogadoPodeEditar" type="button" class="btn btn-sm btn-secondary" v-b-tooltip title="Alterar Senha" v-canaccess="'/colaborador/senha'" @click="openSenha({ colaboradorId: item.colaboradorId })">
                                                <i class="fa fa-lock"></i>
                                            </button>
                                           
                                            <a v-bind:href="'colaborador/edit/'+item.colaboradorId" class="btn btn-sm btn-primary" v-if="item.colaboradorLogadoPodeEditar || (item.ehDisponivel ? ehAdministracaoNacional : false)" v-b-tooltip title="Editar" v-canaccess="'/colaborador/edit'"><i class="fa fa-pencil"></i></a>
                                           
                                            <a v-bind:href="'colaborador/details/'+item.colaboradorId" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes" v-canaccess="'/colaborador/details'"><i class="fa fa-search"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="card-block no-padding">
                            <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                        </div>
                        <button class="btn-large-40 btn-red uppercase pull-left btn-header" @click="onExportFilters()">
                            Exportar Consulta
                        </button>
                    </div>
                    <div>
                        <h2 class="text-center" v-if="!filtro">Faça uma busca para listar os colaboradores</h2>
                    </div>
                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogCreate" :hide-footer="true" title="Novo Candidato">
            <form-create v-if="dialogCreate" @on-saved="onSaved" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogSenha" :hide-footer="true" title="Alterar Senha">
            <form-senha v-if="dialogSenha" :colaborador-id="colaboradorId" @on-saved="hideAll()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogoEscolaCargo" :hide-footer="true" title="Adicionar Colaborador a uma Escola">
            <form-add-escola-cargo v-if="dialogoEscolaCargo" :colaborador-id="colaboradorId" :colaborador="colaborador" @on-saved="hideAll()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogInativar" :hide-footer="true" title="Inativar Colaboradores">
            <form-inativar v-if="dialogInativar" @on-saved="hideAll()" @on-back="hideAll()" />
        </b-modal>


    </main>

</template>

<script>

    import auth from '@/common/auth'
    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import { Cache } from '@/common/cache.js'
    import formCreate from './form-create'
    import formSenha from './form-senha'
    import formInativar from './form-inativar'

    import formAddEscolaCargo from './form-add-escola-cargo'

    export default {
        name: 'colaborador',
        mixins: [base],
        components: { formCreate, formSenha, formInativar, formAddEscolaCargo },
        data() {

            return {

                escolaLogadaId: 0,
                ehAdministracaoNacional: 0,
                colaborador: "",
                colaboradorHierarquia: {},
                resources: {
                    filter: 'colaborador',
                },

                dialogCreate: false,
                dialogInativar: false,
                dialogEdit: false,
                dialogSenha: false,
                dialogoEscolaCargo: false,
                dialogDetails: false,
                buscaAvancada: false,
                filtro: false,
                model: {},
                municipioPorEstado: false,
                carregandoEstado: false,
                carregandoMesoRegiao: false,
                carregandoMicroRegiao: false,
                carregandoNanoRegiao: false,
                colaboradorId: 0,
                escolaIdHover: 0,
                colaboradorIdHover: 0,
                mostraBotaoAddCargoEscola: false,
                usuarioLogado: 0,
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    attributeBehavior: "ListagemColaboradoresCandidatos",
                    situacaoJobsId: "",
                    regiaoId: "",
                    estadoId: "",
                    cargoId: "",
                    escolaId: "",
                    mesoRegiaoId: "",
                    municipioId: "",
                    microRegiaoId: "",
                    nanoRegiaoId: ""
                },

                result: {
                    total: 0,
                    items: [],
                    municipios: []
                }
            }
        },
        methods: {
            onExportFilters: function () {
                new Api('colaborador/export').export(
                    this.filter
                ).then(data => {
                    var blob = new Blob([data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    var _a = document.createElement("a");
                    document.body.appendChild(_a);
                    _a.style.visibility = 'hidden';
                    _a.target = "_blank";
                    _a.href = window.URL.createObjectURL(blob);
                    _a.download = "exportacao-listagem-colaboradores.xlsx"
                    _a.click();
                    _a.remove();

                });
            },
            trocandoEstado: function () {
                this.filter.municipioId = "";
                this.municipioPorEstado = true;
                setTimeout(() => { this.municipioPorEstado = false; }, 1000);
                
            },
            //@teste
            trocandoMesoRegiao: function () {
                this.filter.municipioId = "";
                this.carregandoMesoRegiao = true;
                setTimeout(() => { this.carregandoMesoRegiao = false; }, 1000);
            },            
            //@teste
            trocandoRegiao: function () {
                this.filter.estadoId = "";
                this.carregandoEstado = true;
                setTimeout(() => { this.carregandoEstado = false; }, 1000);
                this.filter.municipioId = "";
                this.municipioPorEstado = true;
                setTimeout(() => { this.municipioPorEstado = false; }, 1000);
            },
            //@teste
            trocandoMicroRegiao: function () {
                this.filter.estadoId = "";
                this.carregandoMicroRegiao = true;
                setTimeout(() => { this.carregandoMicroRegiao = false; }, 1000);
            },
            //@teste
            trocandoNanoRegiao: function () {
                this.filter.nanoRegiaoId = "";
                this.carregandoNanoRegiao = true;
                setTimeout(() => { this.carregandoNanoRegiao = false; }, 1000);
            },
            
            openEdit: function (model) {
                this.$router.push({ path: '/colaborador/edit/' + model.colaboradorId });
            },
            openInativar: function () {
                this.dialogInativar = true;
            },
            openSenha: function (model) {
                this.colaboradorId = model.colaboradorId;
                this.dialogSenha = true;
            },
            openAddEscolaCargo: function (model) {
                this.colaboradorId = model.colaboradorId;
                this.colaborador = model.nmCompleto;                
                this.dialogoEscolaCargo = true;
            },
            openDetails: function (model) {
                this.$router.push({ path: '/colaborador/details/' + model.colaboradorId });
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function (data) {
                this.hideAll();
                this.openEdit(data.data)
            },
            hideAll: function () {
                this.dialogInativar = false;
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogSenha = false;
                this.dialogoEscolaCargo = false;
            },

            buscaAvancadaToggle: function () {
                this.buscaAvancada = !this.buscaAvancada;
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;

                this.filtro = true;
                this.filter.pageIndex = 1;
                this.setFiltros();
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {

                if (this.filter.telefoneNumero) this.filter.telefoneNumero = this.filter.telefoneNumero.replace(/\D+/g, '');
                if (this.filter.celularNumero) this.filter.celularNumero = this.filter.celularNumero.replace(/\D+/g, '');
                if (this.filter.cpf) this.filter.cpf = this.filter.cpf.replace(/\D+/g, '');
                
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    
                    if (data.summary) this.result.total = data.summary.total;

                    data.dataList = data.dataList.map(item => {
                        if (item.collectionColaboradorEscola)
                            item.collectionColaboradorEscola = item.collectionColaboradorEscola
                                .sort((a, b) => { return a.escola.nomeEscola > b.escola.nomeEscola });
                        return item;
                    });

                    this.result.items = data.dataList;
                    
                    localStorage.resulBusca = JSON.stringify(this.result.items);
                    
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },            
            setFiltros: function () {
                localStorage.filtros = JSON.stringify(this.filter);
            },
            getFiltros: function () {                
                //console.log("filtros", localStorage.filtros);
                if (localStorage.filtros) {
                    this.filter = JSON.parse(localStorage.filtros);
                    //this.municipioPorEstado = true;
                    //this.carregaComboMunicipio();
                }
            },
            executeClear: function () {
                this.filter = {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    attributeBehavior: "ListagemColaboradoresCandidatos",
                    situacaoJobsId: "",
                    regiaoId: "",
                    estadoId: "",
                    cargoId: "",
                    escolaId: "",
                    mesoRegiaoId: "",
                    municipioId: "",
                    microRegiaoId: "",
                    nanoRegiaoId: ""
                };
               
                this.filtro = false;
                this.filter.pageIndex = 1;
                this.setFiltros();
                this.executeLoad();
                
            },
            getResultadoBusca: function () {                
                if (localStorage.resulBusca) {
                    this.result.items = JSON.parse(localStorage.resulBusca);
                    //console.log('lista ', this.result.items);
                }                
                this.filtro = true;
            },
            onMouseOverEscola: function () {
            },
            exibeAddCargoEscola: function () {//@TASK_14818
                new Api('ColaboradorEscolaCargo/DataItems').get({ attributeBehavior:"exibeAddCargoEscola" }).then(data => {
                    if (data.dataList.length > 0) {
                        this.result.cargos = data.dataList;
                        this.mostraBotaoAddCargoEscola = true;                        
                    }
                    else {
                        this.result.cargos = [];
                        this.mostraBotaoAddCargoEscola = false;                       
                    }                    
                }, err => {
                    this.defaultErrorResult(err);
                })
                
            },
            carregaComboMunicipio: function () {
                new Api('Municipio/DataItems').get({ estadoId: this.filter.estadoId }).then(data => {
                    if (data.dataList.length > 0 && this.filter.estadoId > 0) {
                        this.result.municipios = data.dataList;
                        setTimeout(() => { this.municipioPorEstado = true; }, 1000);                        
                    }
                    else {
                        this.result.municipios = [];                                               
                        setTimeout(() => { this.municipioPorEstado = false; }, 1000);                        
                    }
                }, err => {
                    this.defaultErrorResult(err);
                });
            }
        },

        mounted() {
            this.escolaLogadaId = +auth.currentUser().tenant;
            this.usuarioLogado = auth.currentUser().sub;
            this.ehAdministracaoNacional = this.escolaLogadaId == 276;
            this.exibeAddCargoEscola();
            this.getFiltros();
            this.getResultadoBusca();

            //this.carregaComboMunicipio();
        }
    };
</script>
<style scoped>    
    span[name=nmescolas]:hover {
        background-color: #ffd800;
        font-weight: bold;
    }

    .destaca {
        font-weight: bold;
        background-color: #ffd800;
    }
    
</style>